<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-access-mediums-gantner-data-provider
            v-slot="memberAccessMediumsGantnerScope"
            :member-id="memberId"
        >
            <kgr-member-access-mediums-gantner
                :member-id="memberId"
                :access-mediums="memberAccessMediumsGantnerScope.data"
                :is-creatable="isCreatable"
                @updated="onUpdate(memberAccessMediumsGantnerScope.reload)"
            />
        </kgr-member-access-mediums-gantner-data-provider>

        <hr class="kgr-separator kgr-separator--light" />

        <kgr-member-access-mediums-intra-key-data-provider
            v-slot="memberAccessMediumsIntraKeyScope"
            :member-id="memberId"
        >
            <kgr-member-access-mediums-intra_key
                :club-id="clubId"
                :member-id="memberId"
                :access-mediums="memberAccessMediumsIntraKeyScope.data"
                :is-creatable="isCreatable"
                @updated="onUpdate(memberAccessMediumsIntraKeyScope.reload)"
            />
        </kgr-member-access-mediums-intra-key-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import FormScaffold from '../../components/common/form/FormScaffold';
import MemberAccessMediumsGantnerDataProvider from '../../components/data-provider/MemberAccessMediumsGantnerDataProvider';
import MemberAccessMediumsGantnerForm from '../../components/members/access-mediums/MemberAccessMediumsGantnerForm';
import MemberAccessMediumsIntraKeyDataProvider from '../../components/data-provider/MemberAccessMediumsIntraKeyDataProvider';
import MemberAccessMediumsIntraKeyForm from '../../components/members/access-mediums/MemberAccessMediumsIntraKeyForm';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-member-access-mediums-gantner-data-provider': MemberAccessMediumsGantnerDataProvider,
        'kgr-member-access-mediums-gantner': MemberAccessMediumsGantnerForm,
        'kgr-member-access-mediums-intra-key-data-provider': MemberAccessMediumsIntraKeyDataProvider,
        'kgr-member-access-mediums-intra_key': MemberAccessMediumsIntraKeyForm,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onUpdate(reload) {
            reload();
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
